import LoginForm from './LoginForm';

export { LoginForm };
export default LoginForm;
